import styled from "styled-components";
import zIndexTypes from "../../../theme/zIndexTypes";
import {
  mediaMaxWidth,
  mediaMaxHeight,
} from "../../utils/mediaQueriesTemplate";

export const DisengageWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  z-index: ${zIndexTypes.modal};
  width: 100vw;
  background: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.6);
  display: none;
  justify-content: center;
  align-items: center;
  height: 100vh;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    display: flex;
  }
`;

export const Modal = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 800px;
  border-radius: 8px;
  padding: 10px 20px;
  margin-left: 60px;
  position: relative;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.4s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.smallDesktop`
    margin-left: unset;
    width: calc(100vw - 30px);
  `}

  ${mediaMaxWidth.tablet`
    position: absolute;
    top: 10px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 20px);
    padding: 10px 10px;
  `}

  ${mediaMaxHeight.phone`
    top: 10px;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #673490;
    }
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
`;

export const Form = styled.form`
  width: 500px;
  margin: 0 auto;

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
  `}
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;

  span {
    font-weight: 700;
  }
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border: ${(props) => props.error !== null && "2px solid #f2008c"};
  border-radius: 4px;
  width: 100%;
  resize: none;
  height: 9em;
  padding: 10px;
  position: relative;
  margin: 30px 0 50px 0;

  ::placeholder {
    opacity: 0.75;
    font-weight: 300;
    font-style: italic;
  }

  &:focus {
    border-color: #f2008c;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const Note = styled.div`
  position: absolute;
  bottom: ${(props) => (props.charsLeft ? "-21px" : "-27px")};
  font-size: 0.9em;
  font-style: italic;
  left: ${(props) => (props.charsLeft ? "unset" : "-5px")};
  right: ${(props) => props.charsLeft && "0"};
  color: ${(props) => props.length === 300 && "#f2008c"};
  font-weight: ${(props) => props.length === 300 && "700"};
`;

export const Asterisk = styled.div`
  display: inline;
  font-size: 2em;
  top: 11px;
  position: relative;
  margin-right: 5px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px 10px;
  }
`;

export const Field = styled.div`
  position: relative;
`;

export const Error = styled.div`
  position: absolute;
  bottom: -45px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #f2008c;
  font-weight: 600;
`;

export const CancelButton = styled.button`
  font-weight: bold;
  color: #f2008c;
  background: transparent;
  border: 1px solid #f2008c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 10px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.15s ease-in-out;
  margin: 5px 10px;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:hover {
    color: #fff;
    background: #bc006d;
    border: 1px solid #f2008c;
  }
`;
